// Resolve a rota atual em módulo/página do menu, para o pulso de presença.
let arvore = [];

export function registrarMenuPresenca(itens) {
  arvore = itens || [];
}

function folhas(nos, modulo, acc) {
  for (const n of nos || []) {
    const mod = modulo || n;
    if (n.children?.length) folhas(n.children, mod, acc);
    else acc.push({ path: n.path, pagina: n.label, modulo: mod.label, icone: mod.icon });
  }
  return acc;
}

export function paginaDaRota(pathname) {
  let melhor = null;
  for (const f of folhas(arvore, null, [])) {
    if (pathname === f.path || pathname.startsWith(`${f.path}/`)) {
      if (!melhor || f.path.length > melhor.path.length) melhor = f;
    }
  }
  if (!melhor && pathname.startsWith("/dashboard")) return { modulo: "Dashboard", pagina: "Dashboard" };
  return melhor ? { modulo: melhor.modulo, pagina: melhor.pagina } : { modulo: "Outras", pagina: pathname };
}

export function iconeDoModulo(modulo) {
  const raiz = arvore.find((n) => n.label === modulo);
  return raiz?.icon || null;
}
